import { useContext, useEffect } from 'react';

const hasData = (data) => {
    if (!data) return false;
    // Handle array format
    if (Array.isArray(data)) return data.length > 0;
    // Handle ByIdStructure format { ids: [], byId: {} }
    if (data.ids) return data.ids.length > 0;
    // Handle object format
    if (typeof data === 'object') return Object.keys(data).length > 0;
    return false;
};

const useGetOnMountForSelectedClient = (Context, params = {}, options = {}) => {
    const { forceRefresh = false } = options;
    const context = useContext(Context);

    useEffect(() => {
        // Skip fetch if data already loaded (unless forceRefresh is true)
        if (!forceRefresh && hasData(context.data)) {
            return;
        }
        context.get(params);
    }, []); // eslint-disable-line
};

export default useGetOnMountForSelectedClient;
